import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-58">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden" data-id="element-59">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center" data-id="element-60">
          <h2 className="text-2xl font-['Montserrat'] font-bold text-[#2E2E2E]" data-id="element-61">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-62">
            <XIcon className="w-6 h-6 text-gray-600" data-id="element-63" />
          </button>
        </div>
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-64">
          {children}
        </div>
      </div>
    </div>;
}